import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css")